import { createStore } from '@stencil/store';

import { VehicleHistoryFieldErrors } from '../interfaces/interface.validation';

const initialState = {
  fields: {
    contactInfo: new Set<string>(),
    vehicleHistory: {} as VehicleHistoryFieldErrors,
  },
  form: {
    contactInfo: new Set<string>(),
    vehicleHistory: new Set<string>(),
    keysModifications: new Set<string>(),
    banner: new Set<string>(),
    vehicleConfig: new Set<string>(),
    vehicle: new Set<string>(),
  },
  result: {
    contactInfo: undefined as boolean,
    vehicleHistory: undefined as boolean,
    keysModifications: undefined as boolean,
    vehicleConfig: undefined as boolean,
    vehicle: undefined as boolean,
  },
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
